import {
  WSActions,
  WSElement,
  WSEmptyState,
  WSInfoBox,
  WSList,
  WSLoader,
  WSPanel,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { queriesPayers } from "@query";
import { MethodWallet } from "../../../shared/components/MethodWallet";
import { selectorMethodValueFromPaymentMethodRef } from "../../../shared/selectors/selectorMethodValueFromPaymentMethodRef";
import { useUserOrganizationName } from "../../../userFeatures/useUserOrganizationName";
import { LabelMethod } from "../../Settings/components/LabelMethod";
import { BankAccount } from "../../PaymentMethods/components/BankAccount";
import { ContainerAccount } from "../../PaymentMethods/components/ContainerAccount";

type Props = {
  onContinue?: () => void;
};

export const ManagedFundingMethod: React.FC<Props> = ({ onContinue }) => {
  const organizationName = useUserOrganizationName();
  const queryPayerSettings = queriesPayers.getCurrentPayerSettings.useQuery();

  const fundingMethod = selectorMethodValueFromPaymentMethodRef(
    queryPayerSettings.data?.payrollSettings?.defaultFundingSource
  );

  return (
    <WSList gap="2XL">
      <WSPanel>
        <WSList gap="2XL">
          <WSElement>
            <WSSectionToolbar title="Add payroll funding method" />
            <WSText.ParagraphSm color="gray500">
              Add a payroll funding method to fund your payrolls and start
              sending payments
            </WSText.ParagraphSm>
          </WSElement>

          {queryPayerSettings.isLoading ? (
            <WSLoader.Spinner size="XS" />
          ) : fundingMethod?.type === "Account" ? (
            <WSPanel>
              <ContainerAccount accountId={fundingMethod.id}>
                {externalBankAccount => (
                  <BankAccount externalBankAccount={externalBankAccount} />
                )}
              </ContainerAccount>
            </WSPanel>
          ) : fundingMethod?.type === "InternalAccount" ? (
            <WSPanel>
              <MethodWallet />
            </WSPanel>
          ) : fundingMethod?.type === "PaymentCard" ? (
            <WSPanel>
              <LabelMethod type="PaymentCard" id={fundingMethod.id} />
            </WSPanel>
          ) : (
            <WSEmptyState
              hasBorder
              orientation="horizontal"
              type="card"
              title="No payroll funding method yet"
              description="Once a payroll funding method is added, it will appear here."
            />
          )}

          <WSInfoBox>
            Payroll funding method is managed by {organizationName} - contact{" "}
            {organizationName} for support.
          </WSInfoBox>
        </WSList>
      </WSPanel>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Continue",
            onClick: onContinue
          }
        ]}
      />
    </WSList>
  );
};
